import React from "react";
import { Tabs, Tab } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledTabs = styled(Tabs)({
  "& .MuiTabs-indicator": {
    backgroundColor: "#007bff",
    height: "4px",
    borderRadius: "4px",
  },
});

const StyledTab = styled(Tab)({
  textTransform: "none",
  fontSize: "16px",
//   fontWeight: "bold",
  color: "#555",
  "&.Mui-selected": {
    color: "#007bff",
  },
  "&:hover": {
    color: "#0056b3",
    transition: "0.3s",
  },
});

const TabsComponent = ({ tabData, activeTab, onTabChange }) => {
  return (
    <StyledTabs
      value={activeTab}
      onChange={onTabChange}
      aria-label="status-tabs"
    >
      {tabData.map(({ name, count }, index) => (
        <StyledTab key={index} label={`${name} (${count})`} value={index} />
      ))}
    </StyledTabs>
  );
};

export default TabsComponent;
